import { Component } from 'react'

import StyledAction from './StyledAction'

interface ShowCardActionProps {
  actionHandler(...args: unknown[]): unknown
  color?: string
  disabled?: boolean
  format?: 'normal' | 'outline'
  orientation?: string
  title: string
  type: string
}

class ShowCardAction extends Component<ShowCardActionProps> {
  static displayName = 'StyledAction'

  static defaultProps = {
    title: '',
    format: 'normal'
  }

  constructor(props: any) {
    super(props)

    this.actionHandler = this.actionHandler.bind(this)
  }

  actionHandler(e: any) {
    const { actionHandler, type, title } = this.props
    e.stopPropagation()
    actionHandler(type, title)
  }

  render() {
    const { title, orientation, color, format, disabled } = this.props
    return (
      <StyledAction
        // @ts-expect-error
        orientation={orientation}
        color={color}
        format={format}
        onClick={this.actionHandler}
        disabled={disabled}
      >
        {title}
      </StyledAction>
    )
  }
}

export default ShowCardAction
